export default "__VITE_ASSET__Dc$Cycuc__"